import React from "react";

const StatusPreview = ({ blockItems }) => {
    const statusTheme = (status) => {
        const normalizedStatus = String(status || "").toLowerCase();
        if (normalizedStatus === "completed") return { color: "#16a34a", bg: "#dcfce7" };
        if (normalizedStatus === "in progress" || normalizedStatus === "in_progress") return { color: "#2563eb", bg: "#dbeafe" };
        return { color: "#b45309", bg: "#ffedd5" };
    };

    return (
        <div className="status-preview-grid">
            {blockItems
                .filter((item) => {
                    const title = item?.statusTitle || item?.title || item?.label || "";
                    const description = item?.description || item?.desc || "";
                    return String(title).trim().length > 0 || String(description).trim().length > 0;
                })
                .map((item, idx) => {
                    const statusValue = item?.status || item?.statusLabel || item?.statusName || "Pending";
                    const title = item?.statusTitle || item?.title || item?.label || "";
                    const description = item?.description || item?.desc || "";
                    const theme = statusTheme(statusValue);

                    return (
                        <div className="status-preview-card" key={`${title || "status"}-${idx}`}>
                            <div className="status-preview-top">
                                <span className="status-preview-title">{title}</span>
                                <span className="status-preview-pill" style={{ color: theme.color, background: theme.bg }}>
                                    {statusValue}
                                </span>
                            </div>
                            <p className="status-preview-desc">{description}</p>
                        </div>
                    );
                })}
        </div>
    );
};

export default StatusPreview;
